export default __webpack_public_path__ + "static/media/pv1.88bc3298.png";